/**
 * Created by alvinoktavianus (https://github.com/alvinoktavianus)
 * on 04/04/18
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { replace } from 'react-router-redux';
import OvoImageIcon from 'assets/images/ovo-button.png';
import LinkAjaImageIcon from 'assets/images/linkaja-logo.png';
import { setOpenInformationModal } from 'actions/outletPages/list';
import { PAYMENT_METHOD_KEY } from 'utils/paymentMethodConstants';
import styles from './styles.css';

class PaymentMethodModal extends Component {
  _getEWalletIconImage = key => {
    switch (key) {
      case PAYMENT_METHOD_KEY.OVO:
        return OvoImageIcon;
      case PAYMENT_METHOD_KEY.TCASH:
        return LinkAjaImageIcon;
    }
  };

  render() {
    const {
      openPaymentMethodModal,
      handleClose,
      paymentMethodList,
    } = this.props;

    return (
      <Modal show={openPaymentMethodModal} onHide={handleClose}>
        <Modal.Body>
          <div className={styles['modal-content']}>
            <h3 className={'text-center'}>
              Congratulations with your new outlets!
            </h3>
            <p className={`text-center ${styles['mt-30px']}`}>
              Your other outlets already use e-wallet payment:
            </p>
            <div className={styles['margin-40']}>
              <p className={'text-center'}>
                {paymentMethodList.map(p => {
                  if (p.outlet_statuses) {
                    return (
                      <img
                        key={p.code}
                        src={this._getEWalletIconImage(p.code)}
                        className={styles['payment-logo']}
                      />
                    );
                  }
                })}
              </p>
            </div>
            <p className={`text-center ${styles['mb-30px']}`}>
              Do you want to activate this e-wallet
              <br />
              for your new outlets also?
            </p>
            <div className={'row'}>
              <div className={'col-md-6'}>
                <button
                  className={`btn btn-default btn-block ${styles.button}`}
                  onClick={handleClose}
                >
                  Maybe Later
                </button>
              </div>
              <div className={'col-md-6'}>
                <button
                  className={'btn btn-primary btn-block'}
                  onClick={() => {
                    this.props.dispatch(setOpenInformationModal(false));
                    this.props.dispatch(replace('/settings/payment_methods'));
                  }}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  const { openPaymentMethodModal, paymentMethodList } = state.outletPages.list;
  return {
    openPaymentMethodModal,
    paymentMethodList,
  };
}

export default connect(mapStateToProps)(PaymentMethodModal);
